<template>
  <div class="print-break-after">
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
    -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <img
        style="width:100%;height:100%;object-fit:contain;object-position:center;cursor:zoom-out;"
        :src="$anm22.getImagePath(picToShow, false)"
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale, gestione spesa mediante modal
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <div class="wg-row input-row measure" style="height:36px;">
        <div class="wg-col wg-xs-2">
          <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Gender', 'Sesso') }}</div>
        </div>
        <div class="wg-col wg-xs-10">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="gender-m"
              type="radio"
              value="m"
              style="display:none;"
              v-model="formData.gender"
            />
            <label class="label-input-radio" for="gender-m">{{ formData.gender === 'm' ? '✔' : '' }}</label>
            <div class="com-anm22-app-text-l" style="margin:0 5px;">M</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="gender-f"
              type="radio"
              value="f"
              style="display:none;"
              v-model="formData.gender"
            />
            <label class="label-input-radio" for="gender-f">{{ formData.gender === 'f' ? '✔' : '' }}</label>
            <div class="com-anm22-app-text-l" style="margin:0 5px;">F</div>
          </div>
        </div>
      </div>
      <template v-if="this.project.category && (this.project.category == 2)">
        <div class="wg-row input-row measure" style="min-height:36px;-ms-flex-wrap:wrap;flex-wrap:wrap;">
          <div class="wg-col wg-xs-4 wg-sm-2">
            <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Remeasured', 'Rimisurato') }}</div>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-4">
            <div class="wg-row" style="align-items:center;">
              <input
                :disabled="mode === 'view'"
                id="remeasured-n"
                type="radio"
                value="0"
                style="display:none;"
                v-model="formData.remeasured"
              />
              <label class="label-input-radio" for="remeasured-n">{{ (!formData.remeasured || (formData.remeasured == "0")) ? '✔' : '' }}</label>
              <div class="com-anm22-app-text-l" style="margin:0 5px;">NO</div>
              <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
              <input
                :disabled="mode === 'view'"
                id="remeasured-y"
                type="radio"
                value="1"
                style="display:none;"
                v-model="formData.remeasured"
              />
              <label class="label-input-radio" for="remeasured-y">{{ (formData.remeasured && (formData.remeasured != "0")) ? '✔' : '' }}</label>
              <div class="com-anm22-app-text-l" style="margin:0 5px;">{{ $anm22.strLang(lang, 'YES', 'SI') }}</div>
            </div>
          </div>
          <div class="wg-col wg-xs-2">
            <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Date', 'Data') }}</div>
          </div>
          <div class="wg-col wg-xs-10 wg-sm-4">
            <div class="wg-row" style="align-items:center;">
              <input
                :disabled="mode === 'view'"
                class="input-elem com-anm22-app-input-date print-row"
                type="date"
                :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
                v-model="formData.remeasuredDate"
              />
            </div>
          </div>
        </div>
      </template>
      <div class="wg-row">
        <div class="wg-row input-row measure" v-for="(input,index) in fields" :key="'input'+index">
          <div class="wg-col wg-xs-1">
            <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
          </div>
          <div class="wg-col wg-xs-4">
            <input
              v-if="input.name == 'manica-piegata-totale'"
              disabled
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="sommaManicaPiegataTot"
            />
            <input
              v-else
              :disabled="mode === 'view'"
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="formData[input.name]"
            />
          </div>
          <div class="wg-col wg-xs-7">
            <div class="input-text com-anm22-app-text-m">{{ input.label }}</div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:40px;">&nbsp;</div>
      <div class="wg-row">
        <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Suit', 'Prova tuta') }}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-6">
          <div class="com-anm22-app-text-m">Base indossata</div>
        </div>
        <div class="wg-col wg-xs-6 print-row">
          <input
            :disabled="mode === 'view'"
            class="com-anm22-app-input-text model-row"
            type="text"
            v-model="formData.base"
          />
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">Tech-Air</div>
        </div>
        <div :class="['wg-col', 'wg-xs-9']">
          <input
            :disabled="mode === 'view'"
            id="tech-air"
            type="checkbox"
            :value="1"
            style="display:none;"
            v-model="formData.techAir"
          />
          <label class="label-input-radio" for="tech-air">{{ formData.techAir ? '✔' : '' }}</label>
        </div>
      </div>
      <div v-if="formData.techAir" class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Type', 'Tipo') }}</div>
        </div>
        <div class="wg-col wg-xs-3">
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.techAirType"
          >
            <option :value="null">{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
            <option v-for="(p, i) in airbagProducts" :key="'abp-' + i" :value="p.idWarehouseProduct">{{ p.name }}</option>
            <option v-if="formData.techAirType === 'V1'" value="V1">V1</option>
            <option v-if="formData.techAirType === 'V2'" value="V2">V2</option>
            <option v-if="formData.techAirType === 'V3'" value="V3">V3</option>
          </select>
          <input
            v-if="mode !== 'edit' && airbagProducts.find(p => p.idWarehouseProduct === formData.techAirType)"
            disabled
            class="input-elem com-anm22-app-input-text"
            type="text"
            v-model="airbagProducts.find(p => p.idWarehouseProduct === formData.techAirType).name"
          />
        </div>
        <div :class="['wg-col', mode == 'edit' ? 'wg-xs-3' : 'wg-xs-1']" style="padding-left:10px;">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Size', 'Taglia') }}</div>
        </div>
        <div :class="['wg-col', mode == 'edit' ? 'wg-xs-3' : 'wg-xs-6']">
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.techAirSize"
          >
            <option value selected disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
            <option
              v-for="(size,index) in ['XS', 'S', 'M', 'L', 'XL', 'XXL']"
              :key="'ta-size-'+index"
              :value="size"
            >{{ size }}</option>
          </select>
          <input
            v-else
            disabled
            class="input-elem com-anm22-app-input-text tech-row"
            type="text"
            v-model="formData.techAirSize"
          />
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Leather', 'Pelle') }}</div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="leather-k"
              type="radio"
              value="kangaroo"
              style="display:none;"
              v-model="formData.leather"
            />
            <label
              class="label-input-radio"
              for="leather-k"
            >{{ formData.leather === 'kangaroo' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Kangaroo', 'Canguro') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="leather-kr"
              type="radio"
              value="kangaroo-racing"
              style="display:none;"
              v-model="formData.leather"
            />
            <label
              class="label-input-radio"
              for="leather-kr"
            >{{ formData.leather === 'kangaroo-racing' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Kangaroo/Racing', 'Canguro/Racing') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="leather-b"
              type="radio"
              value="bovine"
              style="display:none;"
              v-model="formData.leather"
            />
            <label
              class="label-input-radio"
              for="leather-b"
            >{{ formData.leather === 'bovine' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Bovine', 'Bovino') }}</div>
          </div>
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Protections', 'Protezioni') }}</div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="protection-b"
              type="checkbox"
              :value="1"
              style="display:none;"
              v-model="formData.backProtection"
            />
            <label
              class="label-input-radio"
              for="protection-b"
            >{{ formData.backProtection ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Back screen', 'Paraschiena') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="protection-f"
              type="checkbox"
              :value="1"
              style="display:none;"
              v-model="formData.frontProtection"
            />
            <label
              class="label-input-radio"
              for="protection-f"
            >{{ formData.frontProtection ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Bib', 'Pettorina') }}</div>
          </div>
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Fit', 'Vestibilità') }}</div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="fit-r"
              type="radio"
              value="racing"
              style="display:none;"
              v-model="formData.fit"
            />
            <label class="label-input-radio" for="fit-r">{{ formData.fit === 'racing' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Racing', 'Racing') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="fit-c"
              type="radio"
              value="comfort"
              style="display:none;"
              v-model="formData.fit"
            />
            <label class="label-input-radio" for="fit-c">{{ formData.fit === 'comfort' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Comfort', 'Comfort') }}</div>
          </div>
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Model', 'Modello') }}</div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="model-r"
              type="radio"
              value="racing"
              style="display:none;"
              v-model="formData.model"
            />
            <label
              class="label-input-radio"
              for="model-r"
            >{{ formData.model === 'racing' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Racing', 'Racing') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="model-m"
              type="radio"
              value="motard"
              style="display:none;"
              v-model="formData.model"
            />
            <label
              class="label-input-radio"
              for="model-m"
            >{{ formData.model === 'motard' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Motard', 'Motard') }}</div>
          </div>
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Boot', 'Stivale') }}</div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="boot-i"
              type="radio"
              value="internal"
              style="display:none;"
              v-model="formData.boot"
            />
            <label
              class="label-input-radio"
              for="boot-i"
            >{{ formData.boot === 'internal' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Internal', 'Interno') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="boot-e"
              type="radio"
              value="external"
              style="display:none;"
              v-model="formData.boot"
            />
            <label
              class="label-input-radio"
              for="boot-e"
            >{{ formData.boot === 'external' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'External', 'Esterno') }}</div>
          </div>
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">Velcro</div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="velcro-h"
              type="radio"
              value="hook"
              style="display:none;"
              v-model="formData.velcro"
            />
            <label
              class="label-input-radio"
              for="velcro-h"
            >{{ formData.velcro === 'hook' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Hook', 'Uncino') }}</div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="velcro-b"
              type="radio"
              value="buttonhole"
              style="display:none;"
              v-model="formData.velcro"
            />
            <label
              class="label-input-radio"
              for="velcro-b"
            >{{ formData.velcro === 'buttonhole' ? '✔' : '' }}</label>
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >{{ $anm22.strLang(lang, 'Buttonhole', 'Asola') }}</div>
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, 'Top base size', 'Taglia base sopra') }}</div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="formData.tgTop"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, 'Bottom base size', 'Taglia base sotto') }}</div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="formData.tgBottom"
            />
          </div>
        </div>
      </div>
      <!-- NOTE -->
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Notes', 'Note') }}</div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-textarea model-row"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.notes"
          ></textarea>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Last edit', 'Ultima modifica') }}</div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ lastEditDate + ' ' + lastEditUser }}</div>
        </div>
      </div>
      <template v-if="mode === 'edit'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Attachment', 'Allegato') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <template v-if="formData.images">
            <div
              v-for="(img,index) in formData.images.filter(i => i)"
              :key="'img-'+index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
              <img
                class="com-anm22-app-img-fixed-height-m"
                style="position:absolute;top:3px;right:3px;"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="removeImage(index)"
              />
            </div>
          </template>
          <anm22-file-uploader
            :uploadUrl="'vircos/measures-image?idWorldProject='+this.project.idWorldProject"
            :onSuccess="addImage"
          ></anm22-file-uploader>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="saveForm" />
          <input
            type="button"
            style="margin-left:10px;"
            :value="$anm22.strLang(lang, 'Download template', 'Scarica template')"
            @click="downloadTemplate"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploaderInline.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      formData: {},
      tabToShow: "default",
      picToShow: null,
      products: [],
      productCategories: [],
      fields: [
        {
          name: "punto-spalla",
          label: "Punto spalle"
        },
        {
          name: "circ-torace",
          label: "Circonferenza torace"
        },
        {
          name: "circ-vita",
          label: "Circonferenza vita"
        },
        {
          name: "circ-bacino",
          label: "Circonferenza bacino"
        },
        {
          name: "da-pv-a-ginocchio",
          label: "Da punto vita a centro ginocchio"
        },
        {
          name: "da-pv-a-caviglia",
          label: "Da punto vita a caviglia"
        },
        {
          name: "da-pv-a-terra",
          label: "Da punto vita a terra"
        },
        {
          name: "da-cavallo-a-ginocchio",
          label: "Da cavallo a centro ginocchio"
        },
        {
          name: "manica-spalla-gomito",
          label: "Lunghezza manica da spalla a centro gomito"
        },
        {
          name: "manica-gomito-fondo",
          label: "Lunghezza manica da centro gomito a fondo"
        },
        {
          name: "circ-braccio",
          label: "Circonferenza braccio"
        },
        {
          name: "circ-avanbraccio",
          label: "Circonferenza avanbraccio"
        },
        {
          name: "circ-polso",
          label: "Circonferenza polso"
        },
        {
          name: "circ-coscia",
          label: "Circonferenza coscia"
        },
        {
          name: "circ-ginocchio",
          label: "Circonferenza ginocchio"
        },
        {
          name: "circ-polpaccio",
          label: "Circonferenza polpaccio"
        },
        {
          name: "circ-caviglia",
          label: "Circonferenza caviglia"
        },
        {
          name: "lung-vita",
          label: "Lunghezza vita"
        },
        {
          name: "altezza",
          label: "Altezza cm"
        },
        {
          name: "peso",
          label: "Peso kg"
        },
        {
          name: "",
          label: ""
        },
        {
          name: "manica-piegata-totale",
          label: "10+9 lunghezza manica piegata totale"
        },
        {
          name: "centro-davanti",
          label: "Centro davanti"
        },
        {
          name: "lung-fianco",
          label: "Lunghezza fianco"
        },
        {
          name: "ovetto",
          label: "Ovetto"
        },
        {
          name: "tratta-davanti",
          label: "Tratta davanti"
        },
        {
          name: "tratta-dietro",
          label: "Tratta dietro"
        },
        {
          name: "circ-collo",
          label: "Circonferenza collo"
        },
        {
          name: "circ-gomito",
          label: "Circonferenza gomito"
        },
        {
          name: "punto-seno",
          label: "Punto seno (donna)"
        },
        {
          name: "dist-seni",
          label: "Distanza seni (donna)"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    sommaManicaPiegataTot() {
      if (
        !this.formData["manica-spalla-gomito"] &&
        this.formData["manica-gomito-fondo"]
      ) {
        return this.formData["manica-gomito-fondo"];
      } else if (
        this.formData["manica-spalla-gomito"] &&
        !this.formData["manica-gomito-fondo"]
      ) {
        return this.formData["manica-spalla-gomito"];
      } else if (
        !this.formData["manica-spalla-gomito"] &&
        !this.formData["manica-gomito-fondo"]
      ) {
        return;
      }
      return (
        Number(this.formData["manica-spalla-gomito"]) +
        Number(this.formData["manica-gomito-fondo"])
      );
    },
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    airbagProducts() {
      return this.products.filter(p => p.category == 9);
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      this.formData["manica-piegata-totale"] = this.sommaManicaPiegataTot;
      docs.measures = this.formData;
      docs.measures.lastUser = this.user.idWorldUser;
      docs.measures.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    showPic(img) {
      this.picToShow = img;
      this.tabToShow = "pic";
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
    /* Non usano il meccanismo comune per prevenire la chiusura del popup */
    addImage(data) {
      if (!this.formData.images) {
        this.formData.images = [];
      }
      this.formData.images.push(data.url);
      const docs = { ...this.docs };
      docs.measures = this.formData;
      docs.measures.lastUser = this.user.idWorldUser;
      docs.measures.lastUpdate = this.$moment().unix();
      this.$http
        .post("vircos", {
          projectId: this.project.idWorldProject,
          docs: docs
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.measures;
        })
        .catch(error => {
          /* offline */
        });
    },
    removeImage(index) {
      this.formData.images.splice(index, 1);
      const docs = { ...this.docs };
      docs.measures = this.formData;
      docs.measures.lastUser = this.user.idWorldUser;
      docs.measures.lastUpdate = this.$moment().unix();
      this.$http
        .post("vircos", {
          projectId: this.project.idWorldProject,
          docs: docs
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.measures;
        })
        .catch(error => {
          /* offline */
        });
    },
    downloadTemplate() {
      this.$http
        .get("https://www.anm22.it/app/tasks/vircos/template-misure.pdf", {
          responseType: "blob" // important
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
    loadWarehouseData() {
      this.$http
        .get("products")
        .then((response) => {
          this.products = response.data.products;
          this.productCategories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.loadWarehouseData();
    this.formData = { ...this.docs.measures };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
  },
  components: {
    Anm22FileUploader
  }
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-text {
  padding-left: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.pic-viewer {
  height: calc(90vh - 90px);
  width: 100%;
  justify-content: center;
}
.tech-row {
  width: 330px !important;
  max-width: 330px !important;
}
@media print {
  .print-row {
    width: 100% !important;
  }
  .model-row {
    width: 541px !important;
    max-width: 541px !important;
  }

  .input-row.measure {
    margin: 0;
    height: 28px;
    input {
      height: 28px;
      padding: 5px 10px;
    }
  }
  .print-break-after {
    break-after: page;
  }
}
</style>
